import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../../themes'

export const SuccessOrderModalStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  padding: 40px;
  color: ${NATIVE_BASE_COLORS.TEXT[900]};

  .success-order-modal__title {
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: ${FONT_SIZE.LG2};
    font-family: NunitoSansBold;
  }

  .success-order-modal__text {
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoRegular;
  }

  .success-order-modal__button--done {
    text-align: center;
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoSansSemibold;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    cursor: pointer;
    border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
    background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
    color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : COLOR.BLACK_1}
  }
`
